import BaseSuggestionView from 'registration/js/base/suggestion_view';

import question from 'registration/templates/new/suggestion_question.html';
import edit from 'registration/templates/new/suggestion_edit.html';

const SuggestionDialogView = BaseSuggestionView.extend({
    dialogSettings: {
        position: {
            my: 'center center',
            at: 'center center',
            of: window
        },
        width: 'auto',
        dialogClass: 'ui-dialog__no-title'
    },
    templates: {
        edit,
        question
    },
    startSpin() {
        this.$('.js-throbbing-element').addClass('wait');
    },
    stopSpin() {
        this.$('.js-throbbing-element').removeClass('wait');
    }
});

export default SuggestionDialogView;
